import { createElement, useState } from "react";
import { Trans } from "react-i18next";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { deleteHttp } from "@common/api/apiShared";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { DeletionResultWithBlockers } from "@common/components/deleteBlockedDialog/DeleteBlockedDialog.types";
import { IDeleteContractDocumentDialogProps } from "./DeleteContractDocumentDialog";

export function useDeleteContractDocumentHook(props: IDeleteContractDocumentDialogProps) {
    const snackbar = useDotLegalSnackbar();
    const [blockedDeletion, setBlockedDeletion] = useState<DeletionResultWithBlockers | undefined>();

    const deleteMutation = useDotLegalMutation(deleteDocument);
    const deleteDocumentClick = (documentId: string) => {
        deleteMutation.mutateAsync(documentId!, {
            onSuccess: (response: any) => {
                const result: DeletionResultWithBlockers = response.value();

                if (!result.isDeleted) {
                    setBlockedDeletion(result);
                    return;
                }

                props.onDeleted();
                snackbar.show(createElement(Trans, { i18nKey: "documentDeleted", values: { document: props.selectedDocument!.name } }));
            },
        });
    };

    function deleteDocument(documentId: string) {
        return deleteHttp<string>(`/contract/${props.contractId}/documents/${documentId}`);
    }

    return {
        deleteDocumentClick,
        inProgess: deleteMutation.isLoading,
        blockedDeletion,
    };
}
